import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { LanguagesDto } from "./languages-dto";

export class LanguagesResponseModel extends GlobalResponseObject{
    data?: LanguagesDto;

    /**
     * 
     * @param status
     * @param intlCode
     * @param internalMessage
     * @param data
     */

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LanguagesDto){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}